import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

export default (state) => resolveProp('profile.data.2faEnabled', state);
